import styled from 'styled-components';
import { color, label, arch, bp, ease } from '../../styles/tokens';

// Four nail shapes, each in the silhouette of the thing itself: a rounded
// crown over a square base. The frame is the subject.
export const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(16px, 3vw, 28px);

  ${bp.md} {
    grid-template-columns: repeat(4, 1fr);
  }

  .frame {
    ${arch};
    overflow: hidden;
    aspect-ratio: 3 / 4;
    background: ${color.inkSoft};
    border: 1px solid ${color.lineDark};

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.8s ${ease};
    }
  }

  li:hover img {
    transform: scale(1.05);
  }

  figcaption {
    ${label};
    text-align: center;
    margin-top: 16px;
    color: ${color.rose};
  }
`;
